var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    display: flex;\n    flex-direction: column;\n    border-bottom: 1px solid ".concat(theme.borderContent(), ";\n    padding: .5rem 1rem;\n    text-decoration: none;\n    color: ").concat(theme.colorContent(), ";\n  ");
});
var SidebarLink = function (_a) {
    var children = _a.children, to = _a.to, onClick = _a.onClick;
    return (React.createElement(StyledLink, { tabIndex: 1, to: to, onClick: onClick }, children));
};
export default SidebarLink;
var templateObject_1;
